import { render, staticRenderFns } from "./MyCompanyDetails.vue?vue&type=template&id=4ebad5a2&scoped=true"
import script from "./MyCompanyDetails.vue?vue&type=script&lang=js"
export * from "./MyCompanyDetails.vue?vue&type=script&lang=js"
import style0 from "./MyCompanyDetails.vue?vue&type=style&index=0&id=4ebad5a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebad5a2",
  null
  
)

export default component.exports